import { useTranslation } from '@mint-lib/i18n';
import { DocumentSignature } from '@mint-lib/icons';
import { useIsAllowedPermission } from '@mint-lib/profile-helpers';
import { Button, Divider } from '@mint-lib/tw-components';

const isSendOrderFeatureDisabled = true;

const SendOrderBtn = () => {
  const { t } = useTranslation('@myn/planning_v2');

  const isReadOnly = !useIsAllowedPermission('campaignPlanningFeature:modify');
  const isDisabled = isSendOrderFeatureDisabled || isReadOnly;

  return (
    <div className="flex gap-2">
      <Divider orientation="vertical" />
      <Button
        variant="outlined"
        size="medium"
        disabled={isDisabled}
        aria-label="Send order"
      >
        <DocumentSignature />
        {t('Send order')}
      </Button>
    </div>
  );
};

export default SendOrderBtn;
